// Central checkpoint for all non-storage loaded charts.
//=================================================================================================
import { Globals } from "../CoreApp/Globals";
import { transferBuilderInfo } from "./transferBuilderInfo";
import { enumDocCreateStep, enumIWizDataSet, enumDataSource } from "../constants";
import { QPlanManager } from "../CoreApp/QPlanManager";

export function handleBuilderChart() {
  var w = Globals._wsMgr;
  var advanced = false;
  var stillPending = false;
  try {
    var thisStep = Globals._svrChartMgr["chartbuilderstep"];
    var metadata = Globals._svrChartMgr["metadata"];
    var chartdata = Globals._svrChartMgr["chartdata"];
    var docRef = Globals._svrChartMgr["docRef"];
    var doc = docRef ?? w.GetDoc();
    //TODO: All these references can be handled more cleanly.
    //TODO: Data needed for each step + RFC check
    var success = false;
    let docMgr = w.GetDocMgr();
    switch (thisStep) {
      case enumDocCreateStep.loaddocmetadata:
        var iwData = doc.GetIWizData(enumIWizDataSet.interactive);
        var priorDocMgr = iwData.GetPriorDocMgr();
        if (w.fBuilderInfo) {
          //TODO: This should all be compacted into one function.
          transferBuilderInfo(w.fBuilderInfo);
          w.fBuilderInfo = null;
        } else if (w.fDataRefreshInfo) {
          //FE refresh - carry over key settings
          let priorIWizData = w.fDataRefreshInfo;
          let priorDoc = priorIWizData.GetPriorDocMgr().GetCurrentDoc();
          metadata["svrtemplate"] = priorIWizData.GetChartTemplateID();
          if (priorIWizData.fIsPlanChart) metadata["doctype"] = "plan";
          else if (priorIWizData.GetDataSource() == enumDataSource.chartbuilder)
            metadata["doctype"] = "builder";
          metadata["liveChart"] = priorIWizData.fIsServerChart;
          //TODO: persistFH
        }
        // Read launch parameters early
        var launchSettings = Globals._accountInfo.GetLaunchSettings();
        Globals._accountInfo.ClearLaunchSettings();
        success = w.PopulateDocMetadata(metadata, doc, launchSettings);
        if (metadata["doctype"] == "plan") {
          var planMgr = new QPlanManager();
          planMgr.InitPlanManager(w, metadata["planMeta"]);
          var formulas = [];
          if (metadata["formulas"]) {
            formulas = metadata["formulas"].filter(function (aFormula) {
              return !aFormula["name"].includes("_metrics_");
            });
            formulas = formulas.map(function (item) {
              return item["name"];
            });
          }
          Globals._svrChartMgr.SetStaticFormulaInfo(formulas);
          planMgr.UpdatePlanState(metadata["planMeta"]);
          if (metadata["planMeta"]["talentPool"])
            planMgr.UpdateTalentPool(metadata["planMeta"]["talentPool"]);

          planMgr.UpdateContext();
        }
        break;
      case enumDocCreateStep.loadchartdata:
        var dbLoadResult = doc.LoadDynChart(chartdata, w);
        success = dbLoadResult == "success";
        if (doc.IsServerChart()) {
          var subchartData = metadata?.["data"]?.["subcharts"];
          if (subchartData) doc.WireSubChartList(subchartData);
        }
        w.FinishImport();
        w.DoPostBuildSettings(metadata); // this shouldn't exist.
        break;
      case enumDocCreateStep.applyoverrides:
        if (docMgr.IsPlanChart()) {
          var planMgr = w.GetPlanMgr();
          var planMetaData = metadata["planMeta"];
          planMgr.UpdatePlanState(planMetaData);
        }
        w.BroadcastTopic("chartDocumentLoaded", doc);
        w.EndProgress();
        // Trigger publish URL action (?action=publish_PDF^Book) for server charts.
        // Previously SignalDocumentLoadComplete was only invoked by
        // finishstddownload.js (file-based loads), so URL publish actions silently
        // failed for chartID-based loads. Scope is intentionally narrow:
        // ONLY publish actions trigger the signal — other URL actions
        // (refresh/savedoc/signoff) on server charts retain prior behavior to
        // avoid surprising side effects.
        // Peek the queue (do NOT consume); SignalDocumentLoadComplete will shift it.
        var pendingAction = Globals._accountInfo?.fURLAction?.[0];
        if (typeof pendingAction === "string" && pendingAction.startsWith("publish_")) {
          w.SignalDocumentLoadComplete();
        }
        break;
    }

    if (success) {
      //gross global variable for step, need to move to a document property.
      var nextStep = thisStep + 1;
      var hasDataForNextStage = false;
      switch (nextStep) {
        case enumDocCreateStep.loaddocmetadata:
          hasDataForNextStage = metadata != null;
          break;
        case enumDocCreateStep.loadchartdata:
          hasDataForNextStage = chartdata != null;
          break;
        case enumDocCreateStep.applyoverrides:
          hasDataForNextStage = true;
          break;
      }
      if (hasDataForNextStage) {
        var stepMsg = nextStep === enumDocCreateStep.loadchartdata ? "dynloading" : "dynmsg3";
        w.AdvanceBuilderChart(nextStep, metadata, chartdata, stepMsg, doc);
        advanced = true;
      } else {
        switch (nextStep) {
          case enumDocCreateStep.loaddocmetadata:
            break;
          case enumDocCreateStep.loadchartdata:
            doc.DoChartDataQuery();
            // OCN5-6561: chart data query still in flight.
            stillPending = true;
            break;
          case enumDocCreateStep.applyoverrides:
            //How would his case get hit? Planning?
            break;
        }
      }
    } else {
      //TODO: error handling
    }
  } finally {
    if (!advanced) {
      if (!stillPending) {
        w.fChartLoadPending = false;
      }
      w.PrepRenderWS();
      w.RenderWS();
    }
  }
}
